import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

import classes from "./Header.module.scss";
import { Link, useHistory } from "react-router-dom";

const Header = () => {
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (size.width > 811 && menuOpen) {
      setMenuOpen(false);
    }
  }, [size.width, menuOpen]);

  const menuToggleHandler = () => {
    setMenuOpen((p) => !p);
  };

  const ctaClickHandler = () => {
    if (menuOpen) {
      menuToggleHandler();
    }
    history.push("/pro");
  };

  return (
    <>
      <header
        className={classes.header}
        style={{
          backgroundColor: "#fff",
          position: "fixed",
          top: 0,
          zIndex: 1000,
          //   height: size.width > 414 ? null : 45,
          justifyContent: "center",
        }}
      >
        <div
          className={[classes.header__content]}
          style={{
            width:
              window.innerWidth > 1300
                ? window.innerWidth > 1919
                  ? "93%"
                  : window.innerWidth > 1600
                  ? window.innerWidth > 1700
                    ? "95%"
                    : "97%"
                  : "100%"
                : size.width == 1024
                ? "94%"
                : "95%",
          }}
        >
          <div className={classes.header__content__toggle}>
            <Link
              to="/mon-compte"
              style={{
                backgroundColor: "transparent",
                border: "none",
              }}
            >
              <img
                src={
                  menuOpen
                    ? process.env.PUBLIC_URL + "/Userbuttonwhite.png"
                    : process.env.PUBLIC_URL + "/Userbutton.png"
                }
                alt="Userui"
                style={{ width: 15 }}
              />
            </Link>
          </div>
          <Link to="/" className={classes.header__content__logo}>
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              alt="logo"
              style={{
                width: 119,
                position: size.width < 1024 && "absolute",
                // position: "relative",

                left: size.width < 1024 && 0,
                right: size.width < 1024 && 0,
                margin: size.width < 1024 && "auto",
                top: size.width < 1024 && 33,
              }}
            />
          </Link>
          <nav
            style={{
              color: menuOpen ? "white" : "black",
              fontFamily: "Raleway ExtraBold, arial",
              fontWeight: "900",
              fontSize: size.width == 1080 ? 14 : 15,
            }}
            className={`${classes.header__content__nav} ${
              menuOpen && size.width < 811 ? classes.isMenu : ""
            }`}
          >
            <ul>
              <li style={{ justifyContent: menuOpen && "center" }}>
                <Link
                  to="/categories/coiffure"
                  onClick={() => {
                    if (menuOpen) {
                      menuToggleHandler();
                    }
                  }}
                >
                  COIFFURE
                </Link>
              </li>
              <li style={{ justifyContent: menuOpen && "center" }}>
                <Link
                  to="/categories/barber"
                  onClick={() => {
                    if (menuOpen) {
                      menuToggleHandler();
                    }
                  }}
                >
                  BARBER
                </Link>
              </li>
              <li style={{ justifyContent: menuOpen && "center" }}>
                <Link
                  to="/categories/onglerie"
                  onClick={() => {
                    if (menuOpen) {
                      menuToggleHandler();
                    }
                  }}
                >
                  ONGLERIE
                </Link>
              </li>
              <li style={{ justifyContent: menuOpen && "center" }}>
                <Link
                  to="/categories/beaute"
                  onClick={() => {
                    if (menuOpen) {
                      menuToggleHandler();
                    }
                  }}
                >
                  INSTITUT DE BEAUTE
                </Link>
              </li>

              <li style={{ justifyContent: menuOpen && "center" }}>
                <Link
                  to="/categories/bien-etre"
                  onClick={() => {
                    if (menuOpen) {
                      menuToggleHandler();
                    }
                  }}
                >
                  BIEN ÊTRE
                </Link>
              </li>
            </ul>
            {(size.width > 940 || menuOpen) && (
              <button
                className="font-face-rb"
                onClick={ctaClickHandler}
                style={{
                  backgroundColor: "#fff",
                  border: "2px solid black",
                  borderRadius: 10,
                  fontSize: 11,
                  marginLeft: menuOpen ? 0 : size.width > 1650 ? 136 : 0,
                  marginRight:
                    size.width >= 1080 && size.width <= 1366
                      ? 50
                      : size.width == 1024 && 20,
                }}
              >
                ESPACE PRO
              </button>
            )}
            {!menuOpen && (
              <Link
                to="/mon-compte"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  marginLeft: menuOpen
                    ? 0
                    : size.width > 1300
                    ? 60
                    : size.width > 1295
                    ? 30
                    : 0,
                  paddingRight: 0,
                }}
              >
                <img
                  src={
                    menuOpen
                      ? process.env.PUBLIC_URL + "/Userbuttonwhite.png"
                      : process.env.PUBLIC_URL + "/Userbutton.png"
                  }
                  alt="Userui"
                  style={{ width: 22 }}
                />
              </Link>
            )}
          </nav>
          <div className={classes.header__content__toggle}>
            {!menuOpen ? (
              <a onClick={menuToggleHandler} style={{ color: "black" }}>
                <img
                  src={process.env.PUBLIC_URL + "/Iconfeathermenu.png"}
                  alt="Iconfeathermenu"
                  style={{ height: 15 }}
                />
              </a>
            ) : (
              <AiOutlineClose onClick={menuToggleHandler} />
            )}
          </div>
        </div>
      </header>
      {/* securité pour le content + footer */}
      <div style={{ height: 100 }} />
    </>
  );
};

export default Header;
